/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from "react-content-loader";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'
import _ from "lodash";
import Select from "react-select";

import MaterialTable, { MTableToolbar } from "material-table";
import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemText from "@material-ui/core/ListItemText";

const InvoiceAging = () => {
  const AgingtableRef = React.createRef();
  var contractNumber = "";
  var customerName = "";
  const [loading, setLoading] = useState(false);
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const permissionsArray = permissionss.split(",");

  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [isPaneOpen, setPaneOpen] = useState(false);

  const [filters, setFilters] = useState({
    invoice_number: "",
    contract_number: "",
  });
  const [selectedValue, setSelectedValue] = useState(null);
  const [options, setOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const [selectedValue2, setSelectedValue2] = useState(null);
  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue2, setValue2] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [bucketTotals, setBucketTotals] = useState({
    "0-30": 0,
    "31-60": 0,
    "61-90": 0,
    "91-120": 0,
    "121-150": 0,
    "151-180": 0,
    "180+": 0,
  });

  const aging_buckets = {
    "0-30": [0, 30],
    "31-60": [31, 60],
    "61-90": [61, 90],
    "91-120": [91, 120],
    "121-150": [121, 150],
    "151-180": [151, 180],
    "180+": [181, Infinity],
  };

  const [selectedBucket, setSelectedBucket] = useState(null);
  const bucketOptions = Object.keys(aging_buckets).map((bucket) => ({
    value: bucket,
    label: bucket,
  }));

  const handleBucketChange = (selectedOption) => {
    setSelectedBucket(selectedOption);
    // console.log("Selected Bucket:", selectedOption);
    // setFilters((prev) => ({ ...prev, aging_bucket: selectedOption ? selectedOption.value : "" }));
  };

  const handleInputChangeData = (value) => {
    setValue2(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptionsData(value, 1);
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputvalue2, currentPage2);
  };

  const loadOptionsData = async (value, page) => {
    try {
      if (value !== "") {
        setIsLoading2(true);
        const response = await fetch(
          `${API}contracts/contracts/filter/?id=${value}&page=${page}`,
          { headers: authHeader() }
        );
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data;

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error("No data received or empty array from API.");
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading2(false);
    }
  };

  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
  };

  const handleClear = () => {
    setSelectedValue2(null);
    setSelectedValue(null);
    setSelectedBucket(null);

    AgingtableRef.current.onQueryChange();
  };

  const handelInputChange = (value) => {
    setInputValue(value);
    setCurrentPage(1);
    setOptions([]);
    loadOptions(value, 1);
  };

  const handleMenuScrollToBottomName = () => {
    loadOptions(inputValue, currentPage);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (value, page) => {
    try {
      if (value !== "") {
        setIsLoading(true);
        const response = await fetch(
          `${API}parties/party/?customer_name=${value}&page=${page}`,
          { headers: authHeader() }
        );
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data;

          setOptions((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage((prevPage) => prevPage + 1);
        } else {
          console.error("No data received or empty array from API.");
        }
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  //   const fetchAllDataForExport = async () => {
  //     let allData = [];
  //     let currentPage = 0;
  //     const pageSize = 10; // Your page size

  //     while (true) {
  //       const query = {
  //         pageSize,
  //         page: currentPage,
  //         search: '',
  //       };

  //       // Modify the logic here to handle customerName if needed
  //       let customerName = "";
  //       let contractNumber = '';

  //       if (selectedValue) {
  //         customerName = selectedValue.customer_name;
  //       }

  //       if (selectedValue2) {
  //         contractNumber = selectedValue2.contract_number
  //       }

  //       const url = API + "helper/delinquency-aging/?" + "per_page=" + query.pageSize + "&page=" + (query.page + 1) + "&search=" + query.search;

  //       try {
  //         const response = await fetch(url, { headers: authHeader() });
  //         const result = await response.json();

  //         if (result.data.length === 0) {
  //           break;
  //         }

  //         allData = allData.concat(result.data);
  //         currentPage++;
  //       } catch (error) {
  //         console.error("Error fetching data:", error);
  //         break;
  //       }
  //     }

  //     return allData;
  //   };

  let navigate = useNavigate();
  const handleView = (id, status) => {
    // if (status === "Saved" || status === "Completed") {
    navigate("/billing/viewinvoices", { state: id });
    // } else {
    // navigate("/billing/editinvoices", { state: id });
    // }
  };

  const handlePartyView = (id) => {
    navigate("/party/details", { state: id });
  };

  const handleContractView = (id) => {
    navigate("/contract/view", { state: id });
  };

  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
      if (columnDef.field === "total_amount") {
        alignmentStyles[index] = { halign: "right" };
      } else if (columnDef.field === "balance_amount") {
        alignmentStyles[index] = { halign: "right" };
      } else {
        alignmentStyles[index] = { halign: "left" };
      }
    });
    return alignmentStyles;
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => {
    AgingtableRef.current.onQueryChange();
    setPaneOpen(false);
  };

  const clearFilters = () => {
    setFilters({ invoice_number: "" });
    setSelectedValue2(null);
    setSelectedBucket(null);
    setSelectedValue(null);

    AgingtableRef.current.onQueryChange();
    setPaneOpen(false);
  };

  const fetchAllDataForExport = async () => {
    if (selectedValue2) {
      contractNumber = selectedValue2.contract_number;
    }
    let url = `${API}helper/delinquency-aging/?`;
    url += `per_page=1000`; // Large number to fetch all data
    if (filters.invoice_number)
      url += `&invoice_number=${encodeURIComponent(filters.invoice_number)}`;
    if (contractNumber) url += `&contract_number=${contractNumber}`;
    if (selectedBucket) {
      url += `&aging_bucket=${encodeURIComponent(selectedBucket.value)}`;
    }
     if (selectedValue) {
            customerName = selectedValue.customer_name;
          }
    if (customerName) {
      url += `&customer_name=${encodeURIComponent(customerName)}`;
    }
    const response = await fetch(url, { headers: authHeader() });
    const result = await response.json();
    return result.data.results || [];
  };
  useEffect(() => {
    const fetchBucketTotals = async () => {
      let url = API + "helper/delinquency-aging/?";
      if (selectedValue2 && selectedValue2.contract_number) {
        url += `&contract_number=${encodeURIComponent(
          selectedValue2.contract_number
        )}`;
      }
      if (filters.invoice_number) {
        url += `&invoice_number=${encodeURIComponent(filters.invoice_number)}`;
      }
      if (selectedBucket) {
        url += `&aging_bucket=${encodeURIComponent(selectedBucket.value)}`;
      }
       if (selectedValue) {
            customerName = selectedValue.customer_name;
          }
      if (customerName) {
        url += `&customer_name=${encodeURIComponent(customerName)}`;
      }
      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();
        setBucketTotals(result.data.bucket_totals || bucketTotals);
      } catch (error) {
        console.error("Error fetching bucket totals:", error);
      }
    };
    fetchBucketTotals();
  }, [filters, selectedValue2,selectedValue,selectedBucket]);

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="" style={{ position: "relative", minHeight: "138vh" }}>
          {loading === false ? (
            <div
              className="row show_contract show_invoice"
              style={{ marginBottom: "50px" }}
            >
              <div
                className="col-md-12"
                style={{
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  overflowX: "auto",
                }}
              >
                <div className="mb-0">
                  <div className="">
                    <div className=" p-0">
                      <MaterialTable
                        tableRef={AgingtableRef}
                        style={{
                          backgroundColor: "var(--bs-table-bg)",
                          borderBottomWidth: "1px",
                          boxShadow:
                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                        }}
                        title={
                          <>
                            <h5>{t("Delinquency Aging")}</h5>
                            <Typography
                              variant="body2"
                              style={{
                                color: "#245C7F",
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                              onClick={handleDialogOpen}
                            >
                              {t("Summary")}
                            </Typography>
                          </>
                        }
                        columns={[
                          {
                            title: t("Invoice Number"),
                            field: "invoice_number",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Invoice Number")}
                                </div>
                                <div
                                  className="hyperlink"
                                  onClick={() => handleView(rowData.invoice_id)}
                                >
                                  {rowData.invoice_number}
                                </div>
                              </>
                            ),
                          },
                          {
                            title: t("Contract"),
                            field: "contract",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Contract")}
                                </div>
                                <div className="">{rowData.contract}</div>
                              </>
                            ),
                          },
                          {
                            title: t("Customer Name"),
                            field: "customer_name",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Customer Name")}
                                </div>
                                <div className="">{rowData.customer_name}</div>
                              </>
                            ),
                          },
                          {
                            title: `${t("Range")}`,
                            field: "bucket",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Range")}
                                </div>{" "}
                                <div
                                  className=""
                                  //   onClick={() =>
                                  //     handleView(
                                  //       rowData.id,
                                  //       rowData.invoice_status
                                  //     )
                                  //   }
                                >
                                  {rowData.bucket}
                                </div>
                              </>
                            ),
                          },
                          {
                            title: `${t("Amount")}`,
                            field: "amount",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Amount")}
                                </div>{" "}
                                <div className="">
                                  {rowData.amount
                                    ? Helper.Amount(rowData.amount)
                                    : Helper.Amount(0)}
                                </div>
                              </>
                            ),
                          },
                          {
                            title: `${t("Total Amount")}`,
                            field: "total_amount",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Total Amount")}
                                </div>{" "}
                                <div className="text-bold">
                                  {rowData.total_amount
                                    ? Helper.Amount(rowData.total_amount)
                                    : ""}
                                </div>
                              </>
                            ),
                          },
                        ]}
                        data={
                          permissionss &&
                          permissionsArray.includes("view_invoiceheader") ===
                            true
                            ? (query) =>
                                new Promise((resolve, reject) => {
                                  const { orderBy, orderDirection } = query;

                                  if (selectedValue2) {
                                    contractNumber =
                                      selectedValue2.contract_number;
                                    //   customerName = selectedValue.customer_name;
                                    // } else if (selectedValue2) {
                                    //   contractNumber =
                                    //     selectedValue2.contract_number;
                                    // } else if (selectedValue) {
                                    //   customerName = selectedValue.customer_name;
                                  }
                                  if (selectedValue) {
                                    customerName = selectedValue.customer_name;
                                  }
                                  let url = API + "helper/delinquency-aging/?";
                                  url += "per_page=" + query.pageSize;
                                  url += "&page=" + (query.page + 1);
                                  url += "&search=" + query.search;
                                  if (query.search)
                                    url += `&search=${encodeURIComponent(
                                      query.search
                                    )}`;
                                  if (filters.invoice_number)
                                    url += `&invoice_number=${encodeURIComponent(
                                      filters.invoice_number
                                    )}`;
                                  if (contractNumber) {
                                    url += `&contract_number=${contractNumber}`;
                                  }
                                  if (selectedBucket) {
                                    url += `&aging_bucket=${encodeURIComponent(
                                      selectedBucket.value
                                    )}`;
                                  }
                                  if (customerName) {
                                    url += `&customer_name=${encodeURIComponent(
                                      customerName
                                    )}`;
                                  }
                                  if (orderBy) {
                                    url += `&orderBy=${orderBy.field}`;
                                    url += `&orderDirection=${orderDirection}`;
                                  }
                                  fetch(url, { headers: authHeader() })
                                    .then((response) => response.json())
                                    .then((result) => {
                                      resolve({
                                        data:
                                          query.orderBy && query.orderDirection
                                            ? _.orderBy(
                                                result.data.results,
                                                [query.orderBy.field],
                                                [query.orderDirection]
                                              )
                                            : result.data.results,
                                        page: result.page - 1,
                                        totalCount: result.total,
                                      });
                                    });
                                })
                            : []
                        }
                        components={{
                          Toolbar: (props) => (
                            <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                              <MTableToolbar {...props} />
                              <span
                                // onClick={() => setState({ isPaneOpen: true })}
                                onClick={() => setPaneOpen(true)}
                                style={{
                                  color: "#b4b7c5",
                                  paddingRight: "1px",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/static/images/ic-filter.svg"
                                  }
                                  alt=""
                                />
                              </span>
                            </div>
                          ),
                        }}
                        options={{
                          headerStyle: {
                            backgroundColor: "white",
                            color: "#245C7F",
                            fontSize: 11,
                          },
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: "#fff" };
                            }
                          },
                          sorting: true,
                          search: true,
                          toolbar: true,
                          paging: true,
                          pageSize: 10, // make initial page size
                          emptyRowsWhenPaging: false, // To avoid of having empty rows
                          pageSizeOptions: [10, 25, 50, 100],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          exportAllData: true,
                          exportButton: true,
                          exportFileName: "Invoice Aging Reports",

                          exportCsv: async (columns, data) => {
                            try {
                              const allData = await fetchAllDataForExport();
                              if (allData.length === 0) {
                                console.error("No data to export");
                                return;
                              }

                              const title = "Delinquency Aging Report";
                              const currentDate =
                                new Date().toLocaleDateString();
                              const filterInfo = [
                                filters.invoice_number
                                  ? `Filtered by Invoice Number: ${filters.invoice_number}`
                                  : "",
                                filters.contract_number
                                  ? `Filtered by Contract Number: ${filters.contract_number}`
                                  : "",
                              ]
                                .filter(Boolean)
                                .join("\n");

                              const csvContentWithInfo = `${title}\n${
                                filterInfo ? `${filterInfo}\n` : ""
                              }Date: ${currentDate}\n\n`;

                              const csvColumns = columns.filter(
                                (col) => col.field
                              ); // Only columns with a field
                              const csvColumnTitles = csvColumns.map(
                                (column) => column.title
                              );

                              const csvData = allData.map((rowData) => {
                                return csvColumns.map((columnDef) => {
                                  if (rowData.total_amount) {
                                    // Total row
                                    if (columnDef.field === "total_amount") {
                                      return `${t("Total for")} ${
                                        rowData.bucket
                                      }: ${Helper.Amount(
                                        rowData.total_amount
                                      )}`;
                                    } else if (columnDef.field === "bucket") {
                                      return rowData.bucket;
                                    }
                                    return "";
                                  } else {
                                    // Invoice row
                                    if (
                                      columnDef.field === "amount" ||
                                      columnDef.field === "total_amount"
                                    ) {
                                      return rowData[columnDef.field]
                                        ? Number(
                                            rowData[columnDef.field]
                                          ).toFixed(2)
                                        : "";
                                    }
                                    return rowData[columnDef.field] || "";
                                  }
                                });
                              });

                              const csvRows = [csvColumnTitles, ...csvData];
                              const csvContent = `${csvContentWithInfo}${csvRows
                                .map((row) => {
                                  return row
                                    .map((field) => {
                                      if (field === null || field === undefined)
                                        return '""';
                                      if (
                                        typeof field === "string" &&
                                        field.includes(",")
                                      )
                                        return `"${field}"`;
                                      return field;
                                    })
                                    .join(",");
                                })
                                .join("\n")}`;

                              const blob = new Blob([csvContent], {
                                type: "text/csv;charset=utf-8;",
                              });
                              const link = document.createElement("a");
                              link.href = URL.createObjectURL(blob);
                              link.download = "Delinquency_Aging_Report.csv";
                              link.style.display = "none";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            } catch (error) {
                              console.error("Error exporting CSV:", error);
                            }
                          },
                          exportPdf: async (columns, data) => {
                            try {
                              const allData = await fetchAllDataForExport();
                              if (allData.length === 0) {
                                console.error("No data found for PDF export");
                                return;
                              }

                              const doc = new jsPDF();
                              doc.setFont("helvetica", "bold");
                              doc.setFontSize(16);
                              doc.text("Delinquency Aging Report", 14, 10);

                              doc.setFontSize(12);
                              doc.setFont("helvetica", "normal");
                              const currentDate =
                                new Date().toLocaleDateString();
                              doc.text(`Date: ${currentDate}`, 14, 16);

                              if (
                                filters.invoice_number ||
                                filters.contract_number
                              ) {
                                let filterText = "";
                                if (
                                  filters.invoice_number &&
                                  filters.contract_number
                                ) {
                                  filterText = `Filtered by Invoice Number: ${filters.invoice_number} and Contract Number: ${filters.contract_number}`;
                                } else if (filters.invoice_number) {
                                  filterText = `Filtered by Invoice Number: ${filters.invoice_number}`;
                                } else {
                                  filterText = `Filtered by Contract Number: ${filters.contract_number}`;
                                }
                                doc.text(filterText, 14, 22);
                              }

                              const tableStartY =
                                filters.invoice_number ||
                                filters.contract_number
                                  ? 28
                                  : 22;
                              const visibleColumns = columns.filter(
                                (col) => col.field
                              );
                              const columnTitles = visibleColumns.map(
                                (columnDef) => columnDef.title
                              );

                              const pdfData = allData.map((rowData) => {
                                return visibleColumns.map((columnDef) => {
                                  if (rowData.total_amount) {
                                    if (columnDef.field === "total_amount") {
                                      return `${t("Total for")} ${
                                        rowData.bucket
                                      }: ${Helper.Amount(
                                        rowData.total_amount
                                      )}`;
                                    } else if (columnDef.field === "bucket") {
                                      return rowData.bucket;
                                    }
                                    return "";
                                  } else {
                                    if (
                                      columnDef.field === "amount" ||
                                      columnDef.field === "total_amount"
                                    ) {
                                      return rowData[columnDef.field]
                                        ? Number(
                                            rowData[columnDef.field]
                                          ).toFixed(2)
                                        : "";
                                    }
                                    return rowData[columnDef.field] || "";
                                  }
                                });
                              });

                              const tableData = [columnTitles, ...pdfData];
                              // doc.autoTable({
                              autoTable(doc,{
                                head: [tableData[0]],
                                body: tableData.slice(1),
                                startY: tableStartY,
                                styles: { fontSize: 10 },
                                headStyles: {
                                  fillColor: [36, 92, 127],
                                  textColor: [255, 255, 255],
                                },
                                bodyStyles: { textColor: [0, 0, 0] },
                                alternateRowStyles: {
                                  fillColor: [249, 249, 249],
                                },
                                didParseCell: (data) => {
                                  if (data.row.section === "body") {
                                    const totalAmountCell =
                                      data.row.raw[
                                        visibleColumns.findIndex(
                                          (col) => col.field === "total_amount"
                                        )
                                      ];
                                    if (
                                      totalAmountCell &&
                                      String(totalAmountCell).includes(
                                        "Total for"
                                      )
                                    ) {
                                      // Iterate over the cell objects using Object.values
                                      Object.values(data.row.cells).forEach(
                                        (cell) => {
                                          cell.styles.fontStyle = "bold";
                                          cell.styles.fillColor = [
                                            230, 240, 250,
                                          ];
                                        }
                                      );
                                    }
                                  }
                                },
                              });

                              doc.save("Delinquency_Aging_Report.pdf");
                            } catch (error) {
                              console.error("Error exporting PDF:", error);
                            }
                          },
                          actionsColumnIndex: -1,
                          columnsButton: true,
                        }}
                      />
                    </div>
                  </div>
                  <Dialog
                    open={isDialogOpen}
                    onClose={handleDialogClose}
                    PaperProps={{
                      style: {
                        width: "600px", // Increased width for better layout
                        maxWidth: "90%", // Ensures responsiveness on smaller screens
                        borderRadius: "8px", // Rounded corners for a polished look
                      },
                    }}
                  >
                    <DialogTitle
                      style={{
                        fontWeight: "bold",
                        color: "#1E88E5",
                        borderBottom: "1px solid #E0E0E0",
                        paddingBottom: "10px",
                      }}
                    >
                      {t("Delinquency Aging")}
                    </DialogTitle>
                    <DialogContent>
                      <div style={{ overflowX: "auto" }}>
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            marginTop: "10px",
                          }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  textAlign: "left",
                                  padding: "10px",
                                  backgroundColor: "#E3F2FD",
                                  color: "#1565C0",
                                  fontWeight: "bold",
                                  borderBottom: "2px solid #B0BEC5",
                                }}
                              >
                                Bucket
                              </th>
                              <th
                                style={{
                                  textAlign: "right",
                                  padding: "10px",
                                  backgroundColor: "#E3F2FD",
                                  color: "#1565C0",
                                  fontWeight: "bold",
                                  borderBottom: "2px solid #B0BEC5",
                                }}
                              >
                                Total Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(bucketTotals).map(
                              ([bucket, total]) => (
                                <tr
                                  key={bucket}
                                  style={{
                                    backgroundColor:
                                      // total > 0 ? "#E8F5E9" : "transparent",
                                      total > 0 ? "transparent" : "transparent",
                                    borderBottom: "1px solid #F5F5F5",
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: "10px",
                                      // color: total > 0 ? "#2E7D32" : "#424242",
                                      color: total > 0 ? "#757575" : "#757575",
                                      // fontWeight: total > 0 ? "bold" : "normal",
                                    }}
                                  >
                                    {bucket}
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px",
                                      textAlign: "right",
                                      // color: total > 0 ? "#2E7D32" : "#757575",
                                      color: total > 0 ? "#757575" : "#757575",
                                      // fontWeight: total > 0 ? "bold" : "normal",
                                    }}
                                  >
                                    {Helper.Amount(total)}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={handleDialogClose}
                        color="primary"
                        style={{
                          textTransform: "none",
                          fontWeight: "bold",
                          color: "#1E88E5",
                        }}
                      >
                        {t("Close")}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              </div>
            </div>
          ) : (
            <ContentLoader
              viewBox="0 0 1000 550"
              backgroundColor="rgba(0,0,0,0.06)"
              foregroundColor="rgba(0,0,0,0.12)"
            >
              <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
              <circle cx="879" cy="123" r="11" />
              <circle cx="914" cy="123" r="11" />
              <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
              <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
              <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
              <circle cx="880" cy="184" r="11" />
              <circle cx="915" cy="184" r="11" />
              <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
              <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
              <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
              <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="242" r="11" />
              <circle cx="916" cy="242" r="11" />
              <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="303" r="11" />
              <circle cx="917" cy="303" r="11" />
              <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
              <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="363" r="11" />
              <circle cx="916" cy="363" r="11" />
              <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="424" r="11" />
              <circle cx="917" cy="424" r="11" />
              <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
              <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
              <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
              <circle cx="882" cy="484" r="11" />
              <circle cx="917" cy="484" r="11" />
              <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
              <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
              <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
              <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
              <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
              <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
              <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
            </ContentLoader>
          )}
        </div>
      </div>
      <SlidingPane
        isOpen={isPaneOpen}
        title={t("Filters")}
        from="right"
        width="400px"
        onRequestClose={() => setPaneOpen(false)}
      >
        <div style={{ padding: "20px" }}>
          <div className="form-group">
            <label className="col-form-label">{t("Invoice Number")}</label>
            <input
              type="text"
              name="invoice_number"
              value={filters.invoice_number}
              onChange={handleFilterChange}
              className="form-control"
              placeholder={t("Enter Invoice Number")}
            />
          </div>
          {/* <div className="form-group">
            <label>{t("Contract Number")}</label>
            <input
              type="text"
              name="contract_number"
              value={filters.contract_number}
              onChange={handleFilterChange}
              className="form-control"
              placeholder={t("Enter Contract Number")}
            />
          </div> */}
          <div className="form-group">
            <label className="col-form-label">{t("Aging Bucket")}</label>
            <Select
              value={selectedBucket}
              options={bucketOptions}
              isClearable
              onChange={handleBucketChange}
              placeholder={t("Select Aging Bucket")}
            />
          </div>

          <div className="col-xl-12">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">
                {t("Customer Name")}
              </label>
              <div className="col-lg-12">
                <Select
                  value={selectedValue}
                  filterOption={false}
                  options={options}
                  isClearable
                  onInputChange={handelInputChange}
                  getOptionLabel={(options) => options.customer_name}
                  getOptionValue={(options) => options.customer_name}
                  isLoading={isLoading}
                  placeholder={t("Search for Customer(%for All)")}
                  onMenuScrollToBottom={handleMenuScrollToBottomName}
                  onChange={handelChange}
                />
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">
                {t("Contract Number")}
              </label>
              <div className="col-lg-12">
                <Select
                  value={selectedValue2}
                  filterOption={false}
                  options={options2}
                  isClearable
                  onInputChange={handleInputChangeData}
                  getOptionLabel={(options) => options.contract_number}
                  getOptionValue={(options) => options.contract_number}
                  isLoading={isLoading2}
                  placeholder={t("Search for Contract(%for All)")}
                  onMenuScrollToBottom={handleMenuScrollToBottom}
                  onChange={handelChange2}
                />
              </div>
              <input type="hidden" id="contract_status" value="" />
            </div>
          </div>
          <div style={{ marginTop: "20px" }}>
            <button
              className="btn btn-primary"
              onClick={applyFilters}
              style={{ marginRight: "10px" }}
            >
              {t("Apply Filters")}
            </button>
            <button className="btn btn-secondary" onClick={clearFilters}>
              {t("Clear Filters")}
            </button>
          </div>
        </div>
      </SlidingPane>
      {/* <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            isOpen={state1.isPaneOpen}
            title="Filter By"
            subtitle=""
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              setState({ isPaneOpen: false });
            }}
          >
            
              <div className="col-xl-12">
                <div className="form-group row">
                  <label className="col-lg-12 col-form-label">
                    {t("Contract Number")}
                  </label>
                  <div className="col-lg-12">
                    <Select
                      value={selectedValue2}
                      filterOption={false}
                      options={options2}
                      isClearable
                      onInputChange={handleInputChangeData}
                      getOptionLabel={(options) => options.contract_number}
                      getOptionValue={(options) => options.contract_number}
                      isLoading={isLoading2}
                      placeholder={t("Search for Contract(%for All)")}
                      onMenuScrollToBottom={handleMenuScrollToBottom}
                      onChange={handelChange2}
                    />
                  </div>
                  <input type="hidden" id="contract_status" value="" />
                </div>
              </div>
              <div className="col-xl-12">
                <div className="form-group row">
                  <div
                    className="col-lg-12 text-left"
                    style={{ marginTop: "30px" }}
                  >
                    <button
                      type="button"
                      className="clearReceipt btn bg-gradient-secondary ms-auto mb-0"
                      onClick={handleClear}
                    >
                      {t("RESET")}
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      className="filterReceipt btn btn-primary ms-auto mb-0"
                      onClick={()=>Helper.handleSearch(AgingtableRef)}
                    >
                      {t("Apply")}
                    </button>
                    &nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </div>
          </SlidingPane> */}
    </>
  );
};

export default InvoiceAging;
